/* created by CoolGuy on 2019/4/3 */
/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const RATE_API_PREFIX = '//consumer.jfoto.cn/api';
const {
    ajaxCommon
} = Ajax;
const TheApi = API(RATE_API_PREFIX + '/pager');
const RATE_LIST = "RATE_LIST";
const RATE_EDIT = "RATE_EDIT";
const RATE_DETAIL = "RATE_DETAIL";
const RATE_INFO = "RATE_INFO";// 前端临时存储的一些额外需要的数据
const RATE_DETAIL_EMPTY = "RATE_DETAIL_EMPTY";// 清空已有数据
const RATE_STAFF_RATE_LIST = "RATE_STAFF_RATE_LIST";//员工评价
const RATE_RATED_LIST = "RATE_RATED_LIST";// 已评价列表
const RATE_UNRATE_LIST = "RATE_UNRATE_LIST"; // 未评价列表
const RATE_STAFF_TODO = "RATE_RATED_TODO";// 评价链接列表
const RATE_STAFF_SCORE_LIST = "RATE_STAFF_SCORE_LIST";// 员工得分
const RATE_STAFF_SCORE_LIST_DETAIL_SUM = "RATE_STAFF_SCORE_LIST_DETAIL_SUM";// 员工得分的明细的综合 接口
const RATE_STAFF_SCORE_LIST_DETAIL_LIST = "RATE_STAFF_SCORE_LIST_DETAIL_LIST";// 员工得分的明细的 其他非综合 接口
const RATE_SCORE_DETAIL = "RATE_SCORE_DETAIL";// 员工得分明细接口
const RATE_SCORE_DETAIL_DETAIL = "RATE_SCORE_DETAIL_DETAIL";//员工得分明细的明细接口
const RATE_STAFF_SCORE_CURRENT = "RATE_STAFF_SCORE_CURRENT";//当前点击的那一条员工得分详情
const RATE_LIST_EXPORT = "RATE_LIST_EXPORT";
const RATE_UNMARK_LIST_EXPORT = "RATE_UNMARK_LIST_EXPORT";
const RATE_SEND_MESSAGE = "RATE_SEND_MESSAGE";
const RATE_MODIFY_RESULT = "RATE_MODIFY_RESULT";
const RATE_MODIFY_CLOCK = "RATE_MODIFY_CLOCK";
const RATE_CLEAR = "RATE_CLEAR";
const RATE_REBUILD = "RATE_REBUILD";

export default {
    RATE_MODIFY_CLOCK,
    rateModifyClock:(orderid, questionid, value)=>{
      return ajaxCommon({
        data:{
          id:questionid,
          value:value
        },
        api:{
          method:"POST",
          url:`/api/v2/pages/paper/answer/forcesaveone/${orderid}`
        },
        success:(data)=>({
          type:RATE_MODIFY_CLOCK,
          data:data.data
        })
      })
    },
    RATE_MODIFY_RESULT,
    rateModifyResult:(orderid, count, photo, clock)=>{
      let force_clock = clock instanceof Array ? true : false;

      return ajaxCommon({
        data:{
          supplementary_photo:photo,
          customer_satisfied_consult:count,
          clock_photo:clock !== null ? (clock || []).toString() + ',' : undefined
        },
        api:{
          method:"POST",
          url:`/api/v2/pages/paper/${orderid}/collectupone?force_clock=${force_clock}`
        },
        success:(data)=>({
          type:RATE_MODIFY_RESULT,
          data:data.data
        })
      })
    },
    RATE_SEND_MESSAGE,
    rateSendMessage:(paper_id)=>{
      return ajaxCommon({
        data:{},
        api:API(RATE_API_PREFIX)('post')(`pages/paper/${paper_id}/retry`),
        success:(data)=>({
          type:RATE_SEND_MESSAGE,
          data:data.data
        })
      })
    },
    RATE_STAFF_TODO,
    rateStaffTodo: (order_id)=>{
        return ajaxCommon({
            data:{
                order_id
            },
            api:API(RATE_API_PREFIX)('get')('score/order/user/list'),
            success: (data)=>({
                type:RATE_STAFF_TODO,
                data:data.data
            })
        })
    },
    RATE_UNMARK_LIST_EXPORT,
    rateUnmarkListExportByMail:(month, email)=>{
      return ajaxCommon({
        data:{
          month:month,
          originEmail:email
        },
        api:{
          url:RATE_API_PREFIX + "/paper/export_inf/order/unmark",
          method:'get'
        },
        success:(data)=>({
          type:RATE_UNMARK_LIST_EXPORT,
          data
        })
      });
    },
    RATE_LIST_EXPORT,
    rateListExportByMail:(searchKey, search, email)=>{
      delete search.current;
      delete search.total;
      delete search.page;
      delete search.pagesize;

      let sendData = {
        key:JSON.stringify(search),
        originEmail:email
      };

      if(searchKey) {
        sendData.search = searchKey;
      }

      return ajaxCommon({
        data:sendData,
        api:{
          // url:RATE_API_PREFIX + "/pager/export_inf/order/list",
          url:`/api/order/paper/export_list_interface`,
          method:'get'
        },
        success:(data)=>({
          type:RATE_LIST_EXPORT,
          data
        })
      });
    },
    RATE_LIST,
    rateList : (search)=>{
        // 保持antd的风格
        if(search){
            search.page = typeof search.current != 'undefined' ? search.current : (search.page || 1);
            delete search.current;
            delete search.total;
        }
        return ajaxCommon({
            data:search,
            // api:TheApi('get')('order/list'),
            api:{
              url:'/api/order/paper/list',
              method:'get'
            },
            success: (data)=>({
                type:RATE_LIST,
                data
            })
        })
    },
    RATE_EDIT,
    rateEdit:(id,info)=>{
        return ajaxCommon({
            api:'',
            data:info,
            success:(data)=>({
                type:RATE_EDIT,
                data,
            })
        })
    },
    RATE_DETAIL,
    rateDetail:(order_id, questionnaire_id)=>{
        return ajaxCommon({
            api:API(RATE_API_PREFIX + '/paper')('get')('list/show'),
            data:{order_id, questionnaire_id},
            success:(data)=>{
                return ({
                    type:RATE_DETAIL,
                    data,
                    questionnaire_id,
                })
            }
        })
    },
    RATE_INFO,
    rateInfo:(obj)=>{
        return {
            type: RATE_INFO,
            obj,
        }
    },
    RATE_DETAIL_EMPTY,
    rateDetailEmpty:()=>({
        type: RATE_DETAIL_EMPTY,
    }),
    RATE_STAFF_RATE_LIST,
    rateStaffRateList:(search)=> {
        // 保持antd的风格
        if(search){
            search.page = search.current || 1
            delete search.current;
            delete search.total;
        }
        return ajaxCommon({
            api:API(RATE_API_PREFIX+'/paper')('get')('user/info/list'),
            data:search,
            success:(data)=>({
                type: RATE_STAFF_RATE_LIST,
                data,
            })
        })
    },
    RATE_RATED_LIST,
    rateRatedList:(search)=> {
        if(search){
            search.page = search.current || 1
            delete search.current;
        }
        return ajaxCommon({
            api:API(RATE_API_PREFIX+'/paper')('get')('user/answer/list'),
            data:search,
            success:(data)=>({
                type: RATE_RATED_LIST,
                data,
            })
        })
    },
    RATE_UNRATE_LIST,
    rateUnrateList:(search)=> {
        // 保持antd的风格
        if(search){
            search.page = search.current || 1
            delete search.current;
            delete search.total;
        }
        return ajaxCommon({
            api:API(RATE_API_PREFIX+'/paper')('get')('user/wait/list'),
            data:search,
            success:(data)=>({
                type: RATE_UNRATE_LIST,
                data,
            })
        })
    },
    RATE_STAFF_SCORE_LIST,
    rateStaffScoreList:(search)=> {
        // 保持antd的风格
        if(search){
            search.page = search.current || 1
            delete search.current;
            delete search.total;
        }
        return ajaxCommon({
            api:API(RATE_API_PREFIX+'/score')('get')('user/list'),
            data:search,
            success:(data)=>({
                type: RATE_SCORE_DETAIL,
                data,
            })
        })
    },
    RATE_STAFF_SCORE_LIST_DETAIL_SUM,
    rateStaffScoreListDetailSum:(user_id,op)=>ajaxCommon({
        api:API(RATE_API_PREFIX)('get')('score/user/other'),
        data:{user_id,op},
        success:(data)=>({
            type:RATE_STAFF_SCORE_LIST_DETAIL_SUM,
            data,
        })
    }),
    RATE_CLEAR,
    rateClear:(order_id)=>{
      return ajaxCommon({
        api:API(RATE_API_PREFIX)('get')('paper/rate_clear'),
        data:{
          order_id
        },
        success:(data)=>({
          type:RATE_CLEAR,
          data
        })
      })
    },
    RATE_REBUILD,
    rateRebuild:(order_id)=>{
      return ajaxCommon({
        api:API(RATE_API_PREFIX)('get')('paper/rate_rebuild'),
        data:{
          order_id
        },
        success:(data)=>({
          type:RATE_REBUILD,
          data
        })
      })
    },
    RATE_STAFF_SCORE_LIST_DETAIL_LIST,
    rateStaffScoreListDetailList:(search)=> {
        // 保持antd的风格
        if(search){
            search.page = search.current || 1
            delete search.current;
            delete search.total;
        }
       // const {type} = search || {}
        return ajaxCommon({
            api:API(RATE_API_PREFIX)('get')('score/user/byop'),
            data:search,
            success:(data)=>({
                type: RATE_STAFF_SCORE_LIST_DETAIL_LIST,
                data,
                op:search.op,
            })
        })
    },
    RATE_SCORE_DETAIL,
    rateScoreDetail:(search)=> {
        // 保持antd的风格
        if(search){
            search.page = search.current || 1
            delete search.current;
            delete search.total;
        }
        return ajaxCommon({
            api:API(RATE_API_PREFIX+'/score')('get')('pages/user/list'),
            data:search,
            success:(data)=>({
                type: RATE_SCORE_DETAIL,
                data,
            })
        })
    },
    RATE_SCORE_DETAIL_DETAIL,
    rateScoreDetailDetail:(order_id, user_id, op)=> {
        return ajaxCommon({
            api:API(RATE_API_PREFIX+'/score')('get')('pages/user/other'),
            data:{order_id, user_id, op},
            success:(data)=>({
                type: RATE_SCORE_DETAIL_DETAIL,
                data,
            })
        })
    },
    RATE_STAFF_SCORE_CURRENT,
    rateStaffScoreCurrent:(current)=>({
        type: RATE_STAFF_SCORE_CURRENT,
        data: current,
    })
}



// WEBPACK FOOTER //
// ./src/actions/RateAction.js